export default __webpack_public_path__ + "static/media/avatar.969de5f4.svg";